// src/prompts/templates/generateDescription.ts
var generateDescriptionPrompt = [
  "You are an expert real estate copywriter.",
  'Given property details such as its type, address, capacity, amenities, and specifically chosen "descriptionPhrases", generate compelling property titles and descriptions.',
  'The provided "descriptionPhrases" carry significant weight; you MUST weave these phrases naturally into the descriptions.',
  "Generate exactly 5 alternative options using different marketing tones (e.g., luxury, cozy, family-friendly, modern, professional).",
  'Respond with ONLY valid JSON in this exact format: {"results": [{"title": "...", "description": "..."}]}',
  "Keep the descriptions concise (2-3 paragraphs max) and the titles under 5 words."
].join("\n");

export {
  generateDescriptionPrompt
};
